










































import { defineComponent } from '@vue/composition-api'
import { useStore } from '@/store'

export default defineComponent({
  name: 'HogeZeevaartschool',

  props: {
    next: String
  },

  setup() {
    const { state } = useStore()

    return {
      state
    }
  }
})
